/**
 * Local storage for DSOK Daily Menu Admin. Key: dsok.dailyMenu.admin.v1
 * On load: prefer localStorage over bundled demo JSON.
 */
import defaultAdminData from "./dailyMenuAdmin.demo.js";

const STORAGE_KEY = "dsok.dailyMenu.admin.v1";

export function getStoredMenus() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && Array.isArray(parsed.menus)) return parsed;
    }
  } catch (e) {
    console.warn("dailyMenuAdmin storage read failed", e);
  }
  return defaultAdminData;
}

export function getStoredMenu(menuId) {
  const data = getStoredMenus();
  return (data.menus || []).find((m) => m.id === menuId);
}

export function saveMenus(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    return true;
  } catch (e) {
    console.warn("dailyMenuAdmin storage write failed", e);
    return false;
  }
}

export function saveMenu(menu) {
  const data = getStoredMenus();
  const menus = [...(data.menus || [])];
  const idx = menus.findIndex((m) => m.id === menu.id);
  if (idx >= 0) menus[idx] = menu;
  else menus.push(menu);
  return saveMenus({ ...data, menus });
}

export function createNewMenu() {
  const id = `dm-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const daysObj = {};
  days.forEach((day) => {
    daysObj[day] = {
      soups: [],
      meals: [],
      ticker: {},
      updatedAt: new Date().toISOString(),
    };
  });
  const menu = {
    id,
    name: { "sk-SK": "Denné menu", "en-US": "Daily menu" },
    days: daysObj,
    productsById: {},
  };
  saveMenu(menu);
  return menu;
}

export function deleteMenu(menuId) {
  const data = getStoredMenus();
  const menus = (data.menus || []).filter((m) => m.id !== menuId);
  return saveMenus({ ...data, menus });
}
